import { ArrowRight } from "lucide-react";
import { STEPS } from "../../data/content";
import { Button } from "../ui/Button";
import { Reveal } from "../ui/Reveal";
import { SectionHeading } from "../ui/SectionHeading";

export const ComoPedir = () => (
  <section id="comoPedir" aria-labelledby="como-pedir-title" className="relative bg-coal py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading
          id="como-pedir-title"
          align="center"
          eyebrow="Como pedir"
          title="Pedido"
          highlight="Online"
          description="A experiência Ninja completa em apenas 3 passos"
        />
      </Reveal>

      <Reveal stagger={0.15}>
        <ol className="mt-16 grid gap-6 md:grid-cols-3 md:gap-10">
          {STEPS.map(({ id, icon: Icon, titulo, desc }, index) => (
            <li
              key={id}
              data-reveal
              className="relative rounded-card border border-line bg-card px-6 pb-8 pt-10 text-center"
            >
              <span aria-hidden="true" className="absolute right-5 top-3 font-display text-6xl text-white/[0.05]">
                0{index + 1}
              </span>
              <span className="mx-auto grid size-20 place-items-center rounded-full border border-primary/30 bg-night text-primary shadow-glow-sm">
                <Icon className="size-8" aria-hidden="true" />
              </span>
              <h3 className="mt-6 font-display text-3xl tracking-wide">{titulo}</h3>
              <p className="mx-auto mt-3 max-w-xs text-sm leading-relaxed text-muted">{desc}</p>

              {/* Conector entre os passos */}
              {index < STEPS.length - 1 && (
                <span
                  aria-hidden="true"
                  className="absolute -right-[34px] top-1/2 z-10 hidden size-12 -translate-y-1/2 place-items-center rounded-full border border-line bg-coal text-primary md:grid"
                >
                  <ArrowRight className="size-5" />
                </span>
              )}
            </li>
          ))}
        </ol>
      </Reveal>

      <div className="mt-14 flex justify-center">
        <Button to="/cardapio" size="lg" icon={<ArrowRight className="size-5" aria-hidden="true" />}>
          Ir para o cardápio
        </Button>
      </div>
    </div>
  </section>
);
